import { Injectable } from '@angular/core';
import { DexieService } from './dexie.service';
import { Scene } from '../models/scene';
import Dexie from 'dexie';
import { Hotspot } from '../models/hotspot';

@Injectable()

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Scene Service.
 */
export class SceneService
{
	/**
	 * Scene data.
	 */
	private scenes: Scene[];

	/**
	 * Store in IndexedDB.
	 */
	private store: Dexie.Table<Scene, string>;

	/**
	 * Current scene.
	 */
	private currentScene: Scene;

	/**
	 * Active hotspot.
	 */
	private activeHotspot: number;

	/**
	 * Constructor.
	 */
	public constructor(
		private db: DexieService
	)
	{
		this.store = this.db.table('scenes');
	}

	/**
	 * Initalize data.
	 */
	public initalize(): Promise<boolean>
	{
		return this.store.toArray().then(scenes => {
			this.scenes = scenes;
			return true;
		});
	}

	/**
	 * Get scene by Id.
	 *
	 * @param id ID of scene to get
	 * @param withDefaultScene Selects first scene as default, if none found
	 */
	public getScene(id: number, withDefaultScene: boolean = true): Scene
	{
		let scene = withDefaultScene ? this.scenes[0] : null;

		if (this.scenes.filter(item => item['id'] == id).length > 0)
		{
			scene = this.scenes.find(item => item['id'] == id);
		}

		return scene;
	}

	/**
	 * Sets the current scene.
	 */
	public setCurrentScene(scene: Scene)
	{
		this.currentScene = scene;
	}

	/**
	 * Returns the current scene.
	 */
	public getCurrentScene()
	{
		return this.currentScene;
	}

	/**
	 * Returns the active scene.
	 */
	public getActiveScene()
	{
		let scene = this.currentScene;

		if (!scene)
		{
			scene = this.getScene(0);
		}

		return scene;
	}

	/**
	 * Checks if a hotspot is active.
	 */
	public isHotspotActive(id: number)
	{
		return (this.activeHotspot == id);
	}

	/**
	 * Returns the first level hotspots.
	 */
	public getNavigation(): Hotspot[]
	{
		let scene = this.scenes[0];

		return scene.hotspots;
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/services/scene.service.ts